import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-attribution-identity',
  templateUrl: './help-amazon-attribution-identity.component.html'
})
export class HelpAmazonAttributionIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
